<div class="reset-password-container">
  <div class="reset-password-box">
    <div class="back-button" (click)="backToLogin()">
      <i class="pi pi-arrow-left"></i> Back to Login
    </div>
    
    <h1 class="title">Reset Password</h1>

    <!-- Invalid Link Error -->
    <div *ngIf="invalidLink" class="error-message">
      <i class="pi pi-exclamation-triangle"></i>
      <h3>Invalid Reset Link</h3>
      <p>The password reset link is invalid or has expired. Please request a new password reset link.</p>
      <button pButton type="button" 
              label="Back to Login" 
              class="p-button custom-btn"
              (click)="backToLogin()"></button>
    </div>
    
    <!-- Reset Password Form -->
    <div *ngIf="!invalidLink && !submitted; else successMessage">
      <p class="description">Enter your new password below</p>
      
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <div class="input-container">
          <label for="email">Email</label>
          <input formControlName="email" id="email" type="email" class="custom-input" readonly />
        </div>
        
        <div class="input-container">
          <label for="password">New Password</label>
          <input formControlName="password" id="password" type="password" class="custom-input"
              placeholder="Enter new password" />
          <app-form-errors [control]="resetPasswordForm.controls['password']"></app-form-errors>
        </div>
        
        <div class="input-container">
          <label for="confirmPassword">Confirm Password</label>
          <input formControlName="confirmPassword" id="confirmPassword" type="password" class="custom-input"
              placeholder="Confirm new password" />
          <app-form-errors [control]="resetPasswordForm.controls['confirmPassword']"></app-form-errors>
          <small class="text-danger" *ngIf="resetPasswordForm.hasError('passwordMismatch') && resetPasswordForm.get('confirmPassword')?.touched">
            Passwords don't match
          </small>
        </div>
        
        <div class="action-buttons">
          <button pButton type="button" 
                  label="Cancel" 
                  class="p-button-outlined"
                  (click)="backToLogin()"></button>
          <button pButton type="submit" 
                  label="Reset Password" 
                  class="p-button custom-btn"
                  [loading]="isSubmitting"
                  [disabled]="resetPasswordForm.invalid || isSubmitting"></button>
        </div>
      </form>
    </div>
    
    <!-- Success Message -->
    <ng-template #successMessage>
      <div class="success-message">
        <i class="pi pi-check-circle"></i>
        <h3>Password Reset Successful!</h3>
        <p>Your password has been reset successfully. You can now login with your new password.</p>
        <p class="redirecting">Redirecting to login page...</p>
      </div>
    </ng-template>
  </div>
</div>
